import * as React from 'react';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import AuthService from '../../../../services/AuthService';
import CountryService from '../../../../services/CountryService';

const STORAGE_KEY = 'noticeDismissed';

export const NoticeText = () => (
  <>
    <strong>Goods are shipped from the Czech Republic.</strong> For deliveries outside the EU, any import duties,
    taxes, and customs fees are the responsibility of the buyer.
  </>
);

interface INoticeBarState {
  dismissed: boolean;
}

@observer
class NoticeBar extends React.Component<{}, INoticeBarState> {
  // Hidden until mounted, so SSR markup matches and localStorage can be read
  public state = { dismissed: true };

  private ref = React.createRef<HTMLDivElement>();

  private disposeLoginReaction: () => void;

  public componentDidMount() {
    this.setState({ dismissed: this.isDismissed() });
    window.addEventListener('resize', this.updateHeight);

    // AuthService.setLogin clears the dismissal, show the bar again right away
    this.disposeLoginReaction = reaction(
      () => AuthService.GetInstance().loggedIn,
      loggedIn => loggedIn && this.setState({ dismissed: this.isDismissed() })
    );
  }

  public componentDidUpdate() {
    this.updateHeight();
  }

  public componentWillUnmount() {
    this.disposeLoginReaction();
    window.removeEventListener('resize', this.updateHeight);
    document.documentElement.style.setProperty('--notice-bar-height', '0px');
  }

  public render() {
    const countryService = CountryService.GetInstance();

    if (this.state.dismissed || !countryService.isCustomsNoticeRequired(countryService.country)) {
      return null;
    }

    return (
      <div className="notice-bar" role="note" ref={this.ref}>
        <div className="notice-bar__inner">
          <i className="notice-bar__icon" aria-hidden="true">
            i
          </i>
          <p className="notice-bar__text">
            <NoticeText />
          </p>
          <button className="notice-bar__close" aria-label="Dismiss" onClick={this.dismiss}>
            ×
          </button>
        </div>
      </div>
    );
  }

  private isDismissed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  // Fixed header and page offset grow by the bar height (it wraps on mobile)
  private updateHeight = () => {
    const height = this.ref.current ? this.ref.current.offsetHeight : 0;
    document.documentElement.style.setProperty('--notice-bar-height', `${height}px`);
  }

  private dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      // ignore
    }

    this.setState({ dismissed: true });
  }
}

export default NoticeBar;



// WEBPACK FOOTER //
// ./src/components/Header/components/NoticeBar/NoticeBar.tsx